import React, { useState } from "react";
import axios from "axios";
import "../Styles/UploadPhoto.css";

function UploadPhoto({ refreshDashboard }) {

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!title || !file) {
      setError("Please enter photo title and select a photo.");
      return;
    }

    try {

      const formData = new FormData();

      formData.append("file", file);
      formData.append("title", title);
      formData.append("description", description);

      await axios.post(
        "/api/gallery/upload/photo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMessage("Photo uploaded successfully.");

      setTitle("");
      setDescription("");
      setFile(null);

      document.getElementById("photoFile").value = "";

      if (refreshDashboard) {
        refreshDashboard();
      }

    } catch (err) {

      console.error(err);

      setError(
        err.response?.data ||
        "Failed to upload photo."
      );
    }
  };

  return (
    <div className="upload-photo-page">

      <h2>Upload Photo</h2>

      <form onSubmit={handleSubmit}>

        <div className="photo-field">

          <label>Photo Title</label>

          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter photo title"
          />

        </div>


        <div className="photo-field">

          <label>Description</label>

          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter photo description"
            rows="5"
          />

        </div>


        <div className="photo-field">

          <label>Select Photo</label>

          <input
            id="photoFile"
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files[0])}
          />

        </div>


        <button type="submit">
          Upload Photo
        </button>

      </form>


      {message && (
        <p className="photo-success">
          {message}
        </p>
      )}

      {error && (
        <p className="photo-error">
          {error}
        </p>
      )}

    </div>
  );
}

export default UploadPhoto;